import ls from '@/storage/index'
import { getRequest, postRequest } from '@/utils/request.js'
import axios from 'axios'
import { defineStore } from 'pinia'
import { reactive } from 'vue'

const apiUrl = import.meta.env.VITE_API_URL

const useUserStore = defineStore('user', () => {
  const state = reactive({
    initialized: false,
    token: '',
    refreshToken: '',
    id: '',
    username: '',
    realName: '',
  })

  const initialize = async () => {
    const token = getToken()
    if (token) {
      await fetchUserInfoAsync()
    }
  }

  const getToken = () => {
    return ls.get('token')
  }

  const setToken = (token) => {
    state.token = token
    ls.set('token', token)
  }

  const setRefreshToken = (refreshToken) => {
    state.refreshToken = refreshToken
    ls.set('refreshToken', refreshToken)
  }

  const getRefreshToken = () => {
    return ls.get('refreshToken')
  }

  const cleanToken = () => {
    ls.remove('token')
    ls.remove('refreshToken')
  }

  const setUserInfo = (userInfo) => {
    state.id = userInfo.id
    state.username = userInfo.username
    state.realName = userInfo.realName
  }

  const getUserInfo = () => {
    return {
      id: state.id,
      username: state.username,
      realName: state.realName,
    }
  }

  const fetchUserInfoAsync = async () => {
    const response = await getRequest('getLoginUser')
    if (response.success) {
      state.id = response.data.id
      state.username = response.data.username
      state.realName = response.data.realName
    }
  }

  const login = (username, password, captchaKey, captcha) => {
    return new Promise((resolve, reject) => {
      cleanToken()
      postRequest('/login', {
        username,
        password,
        captchaKey,
        captcha,
      })
        .then(async (response) => {
          if (response.success) {
            setToken(response.data.token)
            setRefreshToken(response.data.refreshToken)
            await initialize()
            resolve()
          } else {
            reject('登录失败:' + response.message)
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

  const refreshToken = async () => {
    let refreshToken = getRefreshToken()
    if (!refreshToken) {
      return false
    }
    try {
      cleanToken()
      const response = await axios.request({
        baseURL: apiUrl,
        timeout: 1000 * 30,
        url: '/refreshToken',
        method: 'post',
        headers: {
          'refresh-token': refreshToken,
        },
      })
      const responseData = response.data?.data || response.data
      if (responseData?.token && responseData?.refreshToken) {
        setToken(responseData.token)
        setRefreshToken(responseData.refreshToken)
        return true
      }
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      return false
    }
  }

  const logout = () => {
    return new Promise((resolve, reject) => {
      postRequest('/logout')
        .then((response) => {
          if (response.success) {
            cleanToken()
            resolve()
          } else {
            reject('退出登录失败:' + response.message)
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

  return {
    state,
    getToken,
    setToken,
    getRefreshToken,
    setRefreshToken,
    cleanToken,
    setUserInfo,
    getUserInfo,
    fetchUserInfoAsync,
    initialize,
    login,
    logout,
    refreshToken,
  }
})

export default useUserStore
